import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Return YYYY-MM-DD in local timezone (avoids UTC offset issues)
export function todayISO() {
  return new Date().toLocaleDateString('en-CA'); // en-CA -> 2025-08-16
}